import React from "react";
import "../styles/components/_comingsoon.css";

export default function ComingSoon({ title = "Coming Soon", message }) {
  return (
    <div className="coming-soon-container page">
      <h1>{title}</h1>
      <p>{message || "This page is under construction. Please check back later."}</p>
    </div>
  );
}
